<example-shell
  exampleId="loading" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Loading state"
    [columns]="orderColumns"
    [data]="orders"
    [progressPending]="true">
  </stackline-data-table>
</example-shell>
